import React, { useState, useRef, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

import { ButtonIcon } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const menuAnimation = (openState) => {
  if (openState === null) {
    return keyframes`
      0% {
        border: none;
        padding: var(--cc_size_spacing_s);
        visibility:hidden;
        opacity:0;
      }

      100% {
        border: none;
        padding: var(--cc_size_spacing_s);
        visibility:hidden;
        opacity:0;

      }
    `;
  }

  if (openState === false) {
    return keyframes`
    0% {
      border: 1px solid #E6E8EB;
      padding: var(--cc_size_spacing_s);
      visibility:visible;
      opacity:1;
    }
    100% {
      border: 1px solid #E6E8EB;
      padding: var(--cc_size_spacing_s);
      visibility:hidden;
      opacity:0;
    }
  `;
  }

  return keyframes`
    0% {
      border: 1px solid #E6E8EB;
      padding: var(--cc_size_spacing_s);
      visibility:hidden;
      opacity:0;

    }
    100% {
      border: 1px solid #E6E8EB;
      padding: var(--cc_size_spacing_s);
      visibility:visible;
      opacity:1;
    }
  `;
};

const DropDownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropDownMenu = styled.ul`
  background-color: white;
  position: absolute;
  right: 0;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
  border-radius: var(--cc_size_border_radius_l);
  z-index: 130;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  color: var(--cc_color_link_secondary);
  min-width: 230px;
  animation: ${(props) => menuAnimation(props.isOpen, props.childElementCount)}
    0.05s linear forwards;

  &:before {
    content: '';
    position: absolute;
    top: -14px;
    right: 6px;
    border: 8px solid transparent;
    border-bottom-color: transparent;
    border-bottom-color: white;
    -webkit-filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1));
    filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1));
  }
`;

const ActivateContainer = styled.div`
  padding: 6px 0 6px 6px;

  .dropdown--table-row & {
    padding: 0;
  }
`;

const CardMenu = ({ children, disabled, ...props }) => {
  const wrapperRef = useRef(null);
  const [isOpen, setIsOpen] = useState(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        if (isOpen) {
          setIsOpen(false);
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleMenuClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <DropDownContainer ref={wrapperRef} aria-haspopup="true" {...props}>
      {/* TODO: ADD ACCESSIBILITY TABBING */}
      <ActivateContainer
        onClick={(e) => {
          if (!disabled) handleMenuClick(e);
        }}
      >
        <ButtonIcon
          iconName="dots-horizontal"
          size="tiny"
          disabled={disabled}
          accessibilityLabel={translate('common.menu')}
        />
      </ActivateContainer>
      <DropDownMenu isOpen={isOpen} childElementCount={children.length}>
        {children}
      </DropDownMenu>
    </DropDownContainer>
  );
};

CardMenu.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.any,
};

export default CardMenu;
